import get from 'lodash/get';
import { isArrayEqual } from '@ion/mrdash';

import resolveDeployedConsent from 'api/pipelines/utils/resolveDeployedConsent';

import mapPipelineVarsFromPipelineVariables from './mapPipelineVarsFromPipelineVariables';

export default function isEqualPipelineIntegrations({ deployedRevisions, pipelineIntegrations }) {
  const deployedRevisionsComparator = deployedRevisions.map(deployedRevision => {
    const { consentCategoryCode, consentMode } = resolveDeployedConsent(deployedRevision.consent);

    return {
      integrationId: deployedRevision.integrationId,
      revision: deployedRevision.revision,
      stagedForDelete: deployedRevision.stagedForDelete,
      pipelineVars: deployedRevision.pipelineVars,
      consentCategoryCode,
      consentMode,
      disabled: deployedRevision.disabled,
    };
  });

  const pipelineIntegrationsComparator = pipelineIntegrations.map(pipelineIntegration => {
    const { stagedRevision, pipelineIntegrationConsent } = pipelineIntegration;
    const pipelineVars = mapPipelineVarsFromPipelineVariables({
      pipeline_variables: stagedRevision.playbook.pipeline_variables,
      pipelineVars: stagedRevision.pipelineVars,
    });

    const consentCategoryCode = get(pipelineIntegrationConsent, 'consentCategory.code', null);
    const consentMode = get(pipelineIntegrationConsent, 'mode', null);

    return {
      integrationId: stagedRevision.playbook.integration.id,
      revision: stagedRevision.playbook.revision,
      stagedForDelete: stagedRevision.stagedForDelete,
      pipelineVars: pipelineVars,
      consentCategoryCode,
      consentMode,
      disabled: pipelineIntegration.disabled,
    };
  });

  return isArrayEqual(deployedRevisionsComparator, pipelineIntegrationsComparator);
}
